<template>
	<div ref="myPage" class="dialog-container">
		<div class="dialog scroll" style="max-height: 600px; transform: translate(0, -350px);">
			<form @submit.stop="doValidation()">
				<div class="home-title">
					<div class="title-left" style="font-size: 20px;">
						<span>마이페이지</span>
					</div>
				</div>
				<div class="center">
					<table class="tb-crud-horizon popup-table">
						<colgroup>
							<col width="15%" />
							<col width="85%" />
						</colgroup>
						<tbody>
							<tr>
								<th>아이디</th>
								<td>{{ item.userId }}</td>
							</tr>
							<tr>
								<th>
									이름
									<span class="fcolor-red">*</span>
								</th>
								<td>
									<input
										type="text"
										class="input-crud"
										name="userName"
										v-model="item.userName"
										v-validate="'required'"
										data-vv-as="User Name"
									/>
									<p class="txt-validation" v-if="errors.has('userName')">
										* {{ errors.first("userName") }}
									</p>
								</td>
							</tr>
							<tr>
								<th>이메일</th>
								<td>
									<input
										type="text"
										class="input-crud"
										name="emailFront"
										v-model="item.emailFront"
										style="width: calc(50% - 16px);"
									/>
									<span style="margin: 0 10px;">@</span>
									<input
										type="text"
										class="input-crud"
										name="emailEnd"
										v-model="item.emailEnd"
										style="width: calc(50% - 16px);"
									/>
								</td>
							</tr>
							<tr>
								<th>전화번호</th>
								<td>
									<input
										type="text"
										class="input-crud"
										name="emailFront"
										v-model="item.phoneFront"
										maxlength="3"
										style="width: calc(33.3% - 18.3px);"
									/>
									<span style="margin: 0 10px;">-</span>
									<input
										type="text"
										class="input-crud"
										name="phoneCenter"
										v-model="item.phoneCenter"
										maxlength="4"
										style="width: calc(33.3% - 18.3px);"
									/>
									<span style="margin: 0 10px;">-</span>
									<input
										type="text"
										class="input-crud"
										name="phoneEnd"
										v-model="item.phoneEnd"
										maxlength="4"
										style="width: calc(33.3% - 18.3px);"
									/>
								</td>
							</tr>
							<tr v-if="!isChangePassword">
								<th>비밀번호</th>
								<td>
									<button type="button" class="btn-table" title="Change" @click="doEditPassWord()">
										변경
									</button>
								</td>
							</tr>
							<tr v-if="isChangePassword">
								<th rowspan="3">비밀번호</th>
								<td>
									<label class="label-ps">
										현재 비밀번호 <span class="fcolor-red">*</span>
									</label>
									<input
										type="password"
										class="input-crud"
										name="password"
										v-model="item.password"
										v-validate="'required'"
										data-vv-as="Current Password"
										style="width: 80%;"
										@keyup="doCheckPassword()"
									/>
									<p class="txt-validation" v-if="errors.has('password')">
										* {{ errors.first("password") }}
									</p>
									<p class="txt-validation" v-if="isCurrentPassword">
										* It doesn't match your current password!
									</p>
								</td>
							</tr>
							<tr v-if="isChangePassword">
								<td>
									<label class="label-ps">
										새로운 비밀번호 <span class="fcolor-red">*</span>
									</label>
									<input
										ref="changePassword"
										type="password"
										class="input-crud"
										name="changePassword"
										v-model="item.changePassword"
										v-validate="'required'"
										data-vv-as="Change Password"
										style="width: 80%;"
									/>
									<p class="txt-validation" v-if="errors.has('changePassword')">
										* {{ errors.first("changePassword") }}
									</p>
								</td>
							</tr>
							<tr v-if="isChangePassword">
								<td>
									<label class="label-ps">
										새로운 비밀번호 확인 <span class="fcolor-red">*</span>
									</label>
									<input
										type="password"
										class="input-crud"
										name="confirmPassword"
										v-model="item.confirmPassword"
										v-validate="'required|confirmed:changePassword'"
										data-vv-as="Confirm Password"
										style="width: 80%;"
									/>
									<p class="txt-validation" v-if="errors.has('confirmPassword')">
										* {{ errors.first("confirmPassword") }}
									</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="bottom">
					<button type="button" class="btn-save fright" title="Save" @click="doUpdate()">
						수정
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" style="margin-right: 10px;" @click="doCancel()">
						닫기
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

export default {
	name: "MyPage",
	created() {
		this.logger.debug(this, "created()");
		this.doSelect();
	},
	data() {
		return {
			item: {},
			isChangePassword: false,
			isCurrentPassword: false
		};
	},
	methods: {
		doSelect() {
			this.logger.debug(this, "doSelect()");
			axios
				.post(this.config.contextRoot + "/user/myPage.do", {userId: sessionStorage.userId})
				.then((response) => {
					console.log(response);
					this.item = response.data.item;

					//Email Split
					this.item.emailFront = this.item.emailAddress.split("@")[0];
					this.item.emailEnd = this.item.emailAddress.split("@")[1];
					
					//MobileTelNo Split
					this.item.phoneFront = this.item.mobileTelno.split("-")[0];
					this.item.phoneCenter = this.item.mobileTelno.split("-")[1];
					this.item.phoneEnd = this.item.mobileTelno.split("-")[2];
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
			});
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if(this.isChangePassword && this.isCurrentPassword)
					{
						return;
					}
					this.$confirm("수정하시겠습니까?", "Question", "question").then(() => {
						this.doUpdate();
					});
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doUpdate() {
			this.logger.debug(this, "doUpdate()");
			// 패스워드가 Edit 모드였으면 선 Update
			if(this.isChangePassword && !this.isCurrentPassword)
			{
				this.item.password = this.item.changePassword;
				axios
					.post(this.config.contextRoot + "/user/updatePassWord.do", this.item)
					.then((response) => {
						console.log(response);
					})
					.catch((error) => {
						this.exceptionHandler(this, error);
					});
			}
			// Mobile Phone과 Mail 데이터 병합
			this.item.mobileTelno = this.item.phoneFront + "-" + this.item.phoneCenter + "-" +this.item.phoneEnd;
			this.item.emailAddress = this.item.emailFront + "@" + this.item.emailEnd;
			// User Data 수정
			axios
				.post(this.config.contextRoot + "/user/update.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						this.doClose();
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
			});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.myPage.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.myPage.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("mypage-cancel");
			}.bind(this), 410);
		},
		doEditPassWord() {
			this.logger.debug(this, "doEditPassWord()");
			this.$refs.myPage.children[0].style.transition = "all 0.4s ease-in-out";
			this.$refs.myPage.children[0].style.maxHeight = "650px";
			this.$refs.myPage.children[0].style.transform = "translate(0, -350px)";
			setTimeout(function() {
				this.isChangePassword = true;
			}.bind(this), 410);
		},
		doCheckPassword() {
			this.logger.debug(this, "doCheckPassword()");
			axios
				.post(this.config.contextRoot + "/user/checkPassWord.do", this.item)
				.then((response) => {
					this.isCurrentPassword = !response.data.check;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		}
	}
};
</script>

<style scoped>
.label-ps {
	display: inline-block;
	width: 20%;
	font-weight: 600;
	color: #454545;
	text-align: center;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
</style>